export const getNormalizedFileName = (filename: string): string =>
  filename.replace(/['"]+/g, "");
